export default __webpack_public_path__ + "fonts/refresh_icon.svg";